function ProgressBar({ value, progressColor, bgColor = "#D9D9D9", divClass }) {
  return (
    <div className={`w-full ${divClass}`}>
      <div
        className={` h-[5px] w-full  rounded-full overflow-hidden`}
        style={{ backgroundColor: bgColor }}
      >
        <div
          className={`h-full  w-5  rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${value}%`, backgroundColor: progressColor }}
        />
      </div>
    </div>
  );
}
export default ProgressBar;
